import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export default function ProtectedRoute({children }) {
  const { t } = useTranslation();
  const { user, loading, logout } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-4">
          <img src="/brand/icon-1.png" alt="Pipe4.me" className="w-14 h-14 rounded-xl animate-pulse" />
          <p className="text-slate-500 text-sm">{t("common.loading")}</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  // Member without profile: show blocking screen
  if (user.no_profile === true) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-4 max-w-sm text-center px-6">
          <div className="w-16 h-16 bg-amber-100 rounded-2xl flex items-center justify-center">
            <ShieldCheck className="w-8 h-8 text-amber-500" />
          </div>
          <h2 className="text-xl font-bold text-slate-900">{t("ui.aguardando_perfil")}</h2>
          <p className="text-slate-500 text-sm">
            Sua conta está cadastrada, mas ainda não tem um perfil de permissões atribuído.
            Entre em contato com o administrador do sistema.
          </p>
          <p className="text-xs text-slate-400">{t("ui.conta")}<strong>{user.email}</strong></p>
          <button onClick={logout} className="text-sm text-rose-500 hover:text-rose-600 underline">{t("topbar.logout")}</button>
        </div>
      </div>
    );
  }

  return children;
}


export function OwnerRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "owner") return <Navigate to="/" replace />;

  return children;
}
